import React from 'react';
import {Card, Row} from 'react-bootstrap';
import {ServiceContactInfo} from './ServiceContactInfoGroupV2';

interface ServiceContactInfoCardProps {
  serviceInfo: ServiceContactInfo;
}

const ServiceContactInfoCardV2 = ({serviceInfo}: ServiceContactInfoCardProps): JSX.Element => {
  const {service, email, hours, days, phoneNumber, choice} = serviceInfo;

  return (
    <Card className="text-center overflow-hidden celeste-radius" style={{"border": "1px solid #dfdfdf"}}>
      <Card.Header className="fw-bold text-celeste-primary py-5 justify-content-center text-nowrap">
        <Card.Title className="fw-bold text-celeste-primary">
          <h3 style={{fontSize:'1.3rem'}}>{service}</h3>
        </Card.Title>
      </Card.Header>
      <Card.Body className="p-0 py-5 fs-2">
        <Row>
          <Card.Text className="m-0" style={{fontSize:'1.2rem'}}>{days}</Card.Text>
          <Card.Text style={{fontSize:'1.3rem'}}>{hours}</Card.Text>
        </Row>
        <Row>
          <div className="d-flex justify-content-center align-items-center" style={{fontSize:'1.2rem'}}>
            <Card.Link
              href={`tel:${phoneNumber}`}
              className="fw-bolder m-0 text-celeste-primary"
            >
              {phoneNumber}
            </Card.Link>
            {choice && <Card.Text className={'ms-2 pt-1'}>- {choice}</Card.Text>}
          </div>
          <Card.Link 
            target="blank" 
            href={'mailto:' + email} 
            className="m-0 text-celeste-primary" 
            style={{fontSize:'1.1rem'}}
          >
            {email}
          </Card.Link>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default ServiceContactInfoCardV2;
